import { useState } from 'react';
import { Input } from './ui/input';
import { formatSignedInput, parseSignedInput, formatSignedID } from '../utils/currency';

/**
 * Whole-rupiah amount that may be negative — Pembulatan, and anything like it.
 *
 * A controlled `type="number"` cannot hold a lone "-": the browser reports an
 * empty value for it, so the minus never reaches state and the user is forced
 * to type the digits first. This keeps what was typed as text, so the sign can
 * be entered in any order, and reports the parsed number to `onChange`.
 *
 * The draft is dropped on blur, falling back to the formatted `value`. When the
 * same instance can be reused for a different record, give it a `key` so React
 * remounts it and the draft cannot leak across records.
 */
export function SignedAmountInput({ value, onChange, ...props }) {
  const [draft, setDraft] = useState(null);

  return (
    <Input
      type="text"
      inputMode="decimal"
      value={draft ?? formatSignedID(value || 0, 0)}
      onChange={(e) => {
        const display = formatSignedInput(e.target.value, 0);
        setDraft(display);
        onChange(parseSignedInput(display, 0));
      }}
      onBlur={() => setDraft(null)}
      placeholder="0"
      {...props}
    />
  );
}
